import React, { Component } from 'react';
import { connect } from 'react-redux';

import { TextField } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';

import { asyncValidate } from 'helpers/Validator';
import * as validator from 'helpers/Validator';

import { AccentColor } from 'helpers/AccentColorHelper';

class AssignToBankAccount extends Component {
  render() {
    const { handleSubmit, accounts, error } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div>
          <p style={{ fontSize: '14px' }}>
            If your property has its own seperate bank account, select or create one below.
          </p>
          <div className="row">
            <Field
              component={MultiSelectExtended}
              allowNone
              name="selected_account"
              hintText="Bank Account"
              style={{
                marginTop: '10px',
                fontSize: '14px',
                textAlign: 'left',
                width: '100%',
              }}
              validate={[validator.multi_select_required]}
              data={accounts}
              createText="Create New Bank Account"
              createComponent={
                <div>
                  <Field
                    name="account_name"
                    component={TextField}
                    type="text"
                    floatingLabelText="Bank Account Name/Number"
                    fullWidth
                    style={{ fontSize: '14px' }}
                  />
                  <p
                    style={{
                      color: AccentColor(),
                      fontSize: '11px',
                      textAlign: 'center',
                    }}
                  >
                    {error}
                  </p>
                  <Field
                    name="account_number"
                    component={TextField}
                    floatingLabelText="Chart of Account Number"
                    fullWidth
                    validate={[validator.required, validator.numeric]}
                    style={{ marginTop: '-15px', fontSize: '14px' }}
                  />
                </div>
              }
            />
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    form: ownProps.formName,
  };
};

AssignToBankAccount = compose(
  connect(mapStateToProps),
  reduxForm({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    asyncValidate,
    asyncBlurFields: ['account_number'],
  })
)(AssignToBankAccount);

export default AssignToBankAccount;
